import { mutationTypes } from '@/core/constants'
import store from '@/core/store'

class SetConfigLoki {
	async execute() {
		return store.commit(mutationTypes.LOKI.DISABLE_GLOBAL_LOADING)
	}
}

export default new SetConfigLoki()
